import innerQueryReducer from './queryReducer';

const initialState = {
    query: {
        query: [],
        response: {
            format: 'json-stat'
        }
    },
    lang: '',
    file: '',
    stub: [],
    heading: []

}

export default (state = initialState, action) => {
    switch (action.type) {
        case 'FETCH_PXQ':
            return action.payload;
        case 'SET_SELECTION_LANG':
            return { ...state, lang: action.payload };
        case 'SET_SELECTION_FILE':
            return { ...state, file: action.payload };
        case 'SET_STUB_HEADING_FROM_METADATA':
            return {...state, stub: action.payload.stub, heading: action.payload.heading};
        case 'SET_STUB_HEADING_FROM_COLUMN':
            return {...state, stub: action.payload.stub, heading: action.payload.heading};
        case 'INIT_QUERY_SELECTION_VALUES':
        case 'SET_QUERY_VALUES':
        case 'SET_QUERY_ALL_VALUES':
            const query = { ...state.query, query: innerQueryReducer(state.query.query, action) }
            return { ...state, query }
        default:
            return state;
    }
}